import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    Container,
    Row
} from 'reactstrap'
import { connect } from 'react-redux'
import { select } from '@rematch/select'

import Roles from 'features/auth/Roles'
import View from 'components/View'
import PageTitle from 'components/PageTitle'

import ExportIncidentsFilter from './components/ExportIncidentsFilter'
import ExportMeasures from './components/ExportMeasures'
import ExportIncidents from './components/ExportIncidents'
import ExportAdditionalQuestions from './components/ExportAdditionalQuestions'

import './ExportIndex.scss'

class ExportIndex extends Component {

    static propTypes = {
        organisationId: PropTypes.number,
        roles: PropTypes.array
    }

    constructor(props) {
        super(props)
        this.state = {
            startdate: '',
            enddate: ''
        }
    }

    handleFilterChanged = filter => {
        this.setState({
            startdate: filter.start,
            enddate: filter.end
        })
    }

    render() {
        const {
            organisationId,
            roles
        } = this.props

        const {
            startdate,
            enddate
        } = this.state

        const filterLabel = startdate && enddate
            ? `${ startdate } t/m ${ enddate }`
            : 'Selecteer periode'

        if (roles && roles.indexOf(Roles.DataManager) < 0) {
            return (
                <div className="ao-dashboard">
                    <div>
                        De export functionaliteit is alleen beschikbaar voor data managers
                    </div>
                </div>
            )
        }

        return (
            <View>
                <div className="ao-dashboard">
                    <Container>
                        <Row>
                            <PageTitle>Incidenten exporteren</PageTitle>
                        </Row>

                        <ExportIncidentsFilter
                            start={ startdate }
                            end={ enddate }
                            label={ filterLabel }
                            onSelectionChanged={ this.handleFilterChanged }
                        />

                        <div className="ao-incidents-export__container">
                            <div className="mr-2">
                                <ExportIncidents
                                    organisationId={ organisationId }
                                    startdate={ startdate }
                                    enddate={ enddate }
                                />
                            </div>

                            <div className="mx-2">
                                <ExportMeasures
                                    organisationId={ organisationId }
                                    startdate={ startdate }
                                    enddate={ enddate }
                                />
                            </div>

                            <div className="ml-2">
                                <ExportAdditionalQuestions
                                    organisationId={ organisationId }
                                    startdate={ startdate }
                                    enddate={ enddate }
                                />
                            </div>
                        </div>
                    </Container>
                </div>
            </View>
        )
    }
}

function mapStateToProps(state) {
    return {
        organisationId: select.profile.organisationId(state),
        roles: select.profile.roles(state)
    }
}

export default connect(mapStateToProps, null)(ExportIndex)
